export default __webpack_public_path__ + "static/media/piece-of-broccoli.bd65fe93.png";